import instancesDefaultCoordinates from "./instancesDefaultCoordinates"

export function getMapCenter() {
    const prefix = window.location.hostname.split('.')[0]

    return instancesDefaultCoordinates[prefix] || instancesDefaultCoordinates["staging"]
}